export const getMatchesInString = (
  string: string,
  wordsArray: string[]
): string[] | null => {
  return string.match(new RegExp(wordsArray.join('|'), 'gi'));
};
